import {
  LanguageCode,
  LanguageName,
  languages as supportedLanguages,
} from 'app/utils/supportedLanguages';

type CSATSpecificLanguageCode =
  | 'sq'
  | 'bg'
  | 'zh'
  | 'hr'
  | 'cs'
  | 'el'
  | 'he'
  | 'id'
  | 'fa'
  | 'sk'
  | 'sl'
  | 'uk'
  | 'vi';

type CSATSpecificLanguageName =
  | 'Albanian'
  | 'Bulgarian'
  | 'Chinese'
  | 'Croatian'
  | 'Czech'
  | 'Greek'
  | 'Hebrew'
  | 'Indonesian'
  | 'Persian'
  | 'Slovakian'
  | 'Slovenian'
  | 'Ukrainian'
  | 'Vietnamese';

export type SupportedCSATLanguageCode = LanguageCode | CSATSpecificLanguageCode;

export type SupportedCSATLanguage = {
  code: SupportedCSATLanguageCode;
  label: LanguageName | CSATSpecificLanguageName;
};

/**
 * A list of supported languages specifically for Email CSAT and Phone-SMS CSAT
 * settings.
 */
const supportedCSATLanguages: SupportedCSATLanguage[] = [
  ...supportedLanguages,
  {
    code: 'sq',
    label: 'Albanian',
  },
  {
    code: 'bg',
    label: 'Bulgarian',
  },
  {
    code: 'zh',
    label: 'Chinese',
  },
  {
    code: 'hr',
    label: 'Croatian',
  },
  {
    code: 'cs',
    label: 'Czech',
  },
  {
    code: 'el',
    label: 'Greek',
  },
  {
    code: 'he',
    label: 'Hebrew',
  },
  {
    code: 'id',
    label: 'Indonesian',
  },
  {
    code: 'fa',
    label: 'Persian',
  },
  {
    code: 'sk',
    label: 'Slovakian',
  },
  {
    code: 'sl',
    label: 'Slovenian',
  },
  {
    code: 'uk',
    label: 'Ukrainian',
  },
  {
    code: 'vi',
    label: 'Vietnamese',
  },
];

/**
 * Returns a list of supported languages specifically for Email CSAT and
 * Phone-SMS CSAT settings. The response is sorted and has unique values.
 */
export const getCSATLanguages = (): SupportedCSATLanguage[] =>
  [
    ...new Map(
      supportedCSATLanguages.map((item) => [item.code, item]),
    ).values(),
  ].sort((a, b) => a.label.localeCompare(b.label));
